"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _loader = _interopRequireDefault(require("../../shared/loader"));
var _styles = require("./styles");
var _helpers = require("../../helpers");

/**
 * Component to trigger an operation.
 *
 * @param {*} { children, textStyle, icon, iconStyle, htmlType, type, ...props }
 * @returns {Component}
 */
var Button = function Button(_ref) {
  var children = _ref.children,
    textStyle = _ref.textStyle,
    icon = _ref.icon,
    iconStyle = _ref.iconStyle,
    htmlType = _ref.htmlType,
    type = _ref.type,
    loading = _ref.loading,
    loadingColor = _ref.loadingColor,
    loadingSize = _ref.loadingSize,
    disabled = _ref.disabled,
    className = _ref.className,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "textStyle", "icon", "iconStyle", "htmlType", "type", "loading", "loadingColor", "loadingSize", "disabled", "className", "style"]);
  return _react["default"].createElement(_styles.DefaultBtn, (0, _extends2["default"])({
    type: htmlType,
    colorType: type,
    disabled: loading || disabled,
    loadingSize: loadingSize,
    className: "".concat(className, " ").concat(loading ? "loading" : ""),
    style: style
  }, props), _react["default"].createElement(_styles.ButtonContent, null, loading && _react["default"].createElement(_styles.LoadingFeedback, null, _react["default"].createElement("span", null, _react["default"].createElement(_loader["default"], {
    loadingSize: loadingSize,
    loadingColor: loadingColor
  }))), _react["default"].createElement(_styles.ButtonChildren, {
    style: textStyle
  }, icon && _react["default"].createElement(_styles.Icon, {
    style: iconStyle
  }, icon), children)));
};
Button.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /** set the class of button */
  className: _propTypes["default"].string,
  /** disabled state of the button */
  disabled: _propTypes["default"].bool,
  /** redirect url of link button */
  href: _propTypes["default"].string,
  /** HTML type of button */
  htmlType: _propTypes["default"].oneOf(["button", "reset", "submit"]),
  /** set the icon of button */
  icon: _propTypes["default"].string,
  /** icon style */
  iconStyle: _propTypes["default"].object,
  /** set the loading status of button */
  loading: _propTypes["default"].bool,
  /** loading icon size */
  loadingSize: _propTypes["default"].number,
  /** loading icon color */
  loadingColor: _propTypes["default"].string,
  /** set the handler of click event */
  onClick: _propTypes["default"].func,
  /** make background transparent and invert text and border colors */
  outlined: _propTypes["default"].bool,
  /** make button circular */
  rounded: _propTypes["default"].bool,
  /** size of the button */
  size: _propTypes["default"].oneOf(["small", "default", "large"]),
  /** fit button width to its parent width */
  stretched: _propTypes["default"].bool,
  /** set the style of button */
  style: _propTypes["default"].object,
  /** same as target attr of a but works only when href is specified */
  target: _propTypes["default"].string,
  /** set label style */
  textStyle: _propTypes["default"].object,
  /** set the pattern of button */
  type: _propTypes["default"].oneOf(["main", "primary"])
};
Button.defaultProps = {
  className: null,
  disabled: false,
  htmlType: "button",
  href: null,
  icon: null,
  iconStyle: {},
  loading: false,
  loadingColor: "#fff",
  loadingSize: 18,
  outlined: false,
  onClick: _helpers.noop,
  rounded: false,
  size: "default",
  stretched: false,
  style: {},
  target: null,
  textStyle: {},
  type: "main"
};
var _default = Button;
exports["default"] = _default;